const wrapper = document.querySelector('[data-scroll-hide]');
if (wrapper) {
  let lastY = window.scrollY;
  let ticking = false;
  const THRESHOLD = 80;

  const update = () => {
    const y = window.scrollY;
    wrapper.classList.toggle('floating-btn-wrapper--hidden', y > lastY && y > THRESHOLD);
    lastY = y;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
}
